<template>
  <div class="videoCourse">
    <el-page-header @back="
       goback
      "></el-page-header>

    <el-button
      style="margin-top:10px"
      size="small"
      type="primary"
      @click="addCurriculum"
      icon="el-icon-plus"
    >添加视频课程</el-button>
    <!-- <div class="el-icon-right back" @click="goback"></div> -->
    <div class="table-style">
      <el-table size="small" :data="tableData" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column align="center" width="120" type="index" label="序号"></el-table-column>

        <el-table-column align="center" prop="sort_num" label="排序号"></el-table-column>
        <el-table-column align="center" prop="title" label="标题"></el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="editbtn(scope.row)">修改</el-button>

            <el-button size="small" type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增编辑 -->
    <el-dialog title="提示" :visible.sync="dialogVisible">
      <el-form
        class="form-style"
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        size="small"
        label-position="left"
      >
        <el-form-item label="视频标题" required prop="title">
          <el-input placeholder="请输入视频标题" v-model="form.title" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="视频地址" required prop="video_url">
          <el-input placeholder="请输入视频地址" v-model="form.video_url" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="时长" required prop="duration">
          <el-input placeholder="请输入视频时长" v-model="form.duration" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item label="排序号" required prop="sort_num">
          <el-input-number v-model="form.sort_num" :precision="2"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getVideoList, editVideo, delVideo } from "@/api/admin.js";

export default {
  data() {
    return {
      txtId: "",
      tch_training_video_id: "",
      tableData: [],
      dialogVisible: false,
      form: {
        title: "",
        video_url: "",
        duration: "",
        sort_num: "00.00"
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        duration: [{ required: true, message: "请输入时长", trigger: "blur" }],

        video_url: [
          { required: true, message: "请输入视频地址", trigger: "blur" }
        ],

        sort_num: [
          { required: true, message: "请输入排序号", trigger: "change" }
        ]
      }
    };
  },
  created() {
    console.log(this.$route.query.id);
    this.txtId = this.$route.query.id;
  },
  mounted() {
    this.getVideoList();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    //删除
    del(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delVideo({
            tch_training_video_id: row.id
          }).then(() => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getVideoList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //编辑
    editbtn(row) {
      this.form = row;
      this.tch_training_video_id = row.id;
      console.log(this.tch_training_video_id);

      this.dialogVisible = true;
    },
    //提交
    // submit(form) {
    //   this.$refs[form].validate((valid) => {
    //     if (valid) {
    //       if (this.tch_training_video_id ) {
    //         editVideo({
    //           tch_training_chapter_id : this.txtId,
    //           tch_training_video_id : this.tch_training_video_id,
    //           ...this.form,
    //         }).then((res) => {
    //           console.log(res);
    //           this.$message.success("修改章节成功!");
    //           this.dialogVisible = false;
    //           this.getVideoList();
    //         });
    //       } else {
    //         editVideo({
    //           tch_training_chapter_id: this.txtId,
    //           ...this.form,
    //         }).then((res) => {
    //           console.log(res);
    //           this.dialogVisible = false;
    //           this.$message.success("添加章节成功!");
    //           this.getVideoList();
    //         });
    //       }
    //     }
    //   });
    // },

    submit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.tch_training_video_id === "") {
            editVideo({
              tch_training_chapter_id: this.txtId,
              tch_training_video_id: "",
              ...this.form
            }).then(res => {
              console.log(res);
              this.$message.success("添加章节成功!");
              this.dialogVisible = false;
              this.getVideoList();
            });
          } else {
            console.log(this.tch_training_video_id);
            editVideo({
              tch_training_chapter_id: this.txtId,
              tch_training_video_id: this.tch_training_video_id,
              ...this.form
            }).then(() => {
              this.$message.success("修改章节成功!");

              this.dialogVisible = false;
              this.getVideoList();
            });
          }
        }
      });
    },

    //获取列表
    getVideoList() {
      getVideoList({
        tch_training_chapter_id: this.txtId
      }).then(res => {
        this.tableData = res.tchTrainingChapterList;
      });
    },
    addCurriculum() {
      this.form.sort_num = "00.00";
      this.form.title = "";
      this.form.duration = "";
      this.form.video_url = "";
      this.tch_training_video_id = "";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.videoCourse {
  height: 100%;
  min-height: 100vh;
  background-color: #fff;
  margin: 15px;
  padding: 15px;
  .form-style {
    margin-left: 15px;
  }
  .table-style {
    margin-top: 15px;
  }
}
/deep/ .el-icon-right:before {
  font-size: 25px;
  cursor: pointer;
}
.back {
  float: right;
}
</style>